import axios from "axios";

export const getDeliveries = () => {
    return axios.get("Orders/Deliveries");
}

export const getDeliveryMethodById = (id: string) => {
    return axios.get(`Orders/Delivery/${id}`);
}